export const REGISTER_INFO = 'registerInfo';
export const PROCESS_REGISTER = 'processRegister';
